/**
 * Reconstruct a single data point from PCA scores.
 *
 * @param scores      Single PCA scores vector (length nComponents)
 * @param components  PCA components matrix (nComponents × nFeatures)
 * @param mean        PCA mean vector (length nFeatures)
 * @param nodata      Nodata value in reconstructed data, set to null in output
 * @returns           Reconstructed vector (length nFeatures)
 */
export function pcaReconstructSingle(
  scores: (number|null)[],
  components: number[][],
  mean: number[],
  nodata: number|undefined
): (number|null)[] {
  const nComponents = components.length;
  const nFeatures = components[0].length;
  //console.log(scores);
  //console.log(nComponents);
  if (scores.length !== nComponents) {
    throw new Error("Score vector length must match number of PCA components.");
  }

  if (mean.length !== nFeatures) {
    throw new Error("Mean vector length must match number of features.");
  }

  const result = Array(nFeatures).fill(0);

  for (let f = 0; f < nFeatures; f++) {
    let sum = 0;
    for (let c = 0; c < nComponents; c++) {
      sum += scores[c]! * components[c][f];
    }
    result[f] = sum + mean[f];
  }

  if (nodata) {
    return setNoData(result, nodata);
  }
  return result;
}


export function setNoData(
  vector: number[],
  noDataValue: number
): (number | null)[] {
  return vector.map(v => (v === noDataValue ? null : v));
}
